type ProfileNameParts = {
  full_name?: string | null;
  basic_info?: {
    first_name?: string | null;
    middle_name?: string | null;
    last_name?: string | null;
  } | null;
};

type DependentGuardianFields = {
  guardian_full_name?: string | null;
  guardian?: ProfileNameParts | null;
};

function cleanName(value?: string | null): string | null {
  const trimmed = value?.trim();
  return trimmed || null;
}

export function resolveProfileDisplayName(profile?: ProfileNameParts | null): string | null {
  if (!profile) return null;

  const fullName = cleanName(profile.full_name);
  if (fullName) return fullName;

  return cleanName(
    [
      profile.basic_info?.first_name,
      profile.basic_info?.middle_name,
      profile.basic_info?.last_name,
    ]
      .filter(Boolean)
      .join(' '),
  );
}

export function resolveGuardianDisplayName(profile?: DependentGuardianFields | null): string | null {
  if (!profile) return null;

  return cleanName(profile.guardian_full_name) || resolveProfileDisplayName(profile.guardian);
}
